/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';

export interface FindById4$Params {
  id: string;
  withDcUserId?: boolean;
}

export function findById4(http: HttpClient, rootUrl: string, params: FindById4$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
  const rb = new RequestBuilder(rootUrl, findById4.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('withDcUserId', params.withDcUserId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Resource>;
    })
  );
}

findById4.PATH = '/api/agn-resources/{id}';
